import {
  showPercent,
  showRoundAmount,
  truncateAmount,
  ONE_DAY_PS_PRODUCT_ID,
} from '../../libs/util';
import { groupInteger } from '../../libs/numberFormat';

const Component = ({
  product,
  currency,
  expiredAmount,
  daysLeft,
  productAPR,
  desiredRate,
  traderRateOverride,
  referenceRate,
  notionalCurrency,
}) => {
  const getCurrency = (currency) => {
    if (!currency) {
      return currency;
    }
    return currency.toUpperCase();
  };

  // For 1-day USD products, use notionalCurrency for display
  const displayCurrency =
    currency && getCurrency(currency) === 'USD'
      ? notionalCurrency || 'USD'
      : getCurrency(currency);

  const formatIndicativeAmount = (amount, ccy) => {
    if (!amount) return 0;

    const displayCurrency = getCurrency(ccy);

    // // ONLY for 1-day PST product → truncate
    // if (product?.product_id === ONE_DAY_PS_PRODUCT_ID) {
    // }

    // // Existing behaviour for all other products
    // return showRoundAmount(amount, displayCurrency);
    return groupInteger(truncateAmount(amount, displayCurrency));
  };

  // Trader Rate: system calculated rate
  // For CUSTOM payout: interpolated rate from product curve (passed via traderRateOverride)
  // For MONTHLY/ON_MATURITY: product default rate (calc_adj_apy)
  const traderRate =
    traderRateOverride != null
      ? parseFloat(parseFloat(traderRateOverride).toFixed(2))
      : product && product.calc_adj_apy
        ? parseFloat((product.calc_adj_apy * 100).toFixed(2))
        : null;

  return (
    <>
      <div className="p-2">
        <div className="nk-ivp-summary card-text">
          <div className="row">
            <div className="col-6 border-right">
              <span className="lead-text">
                <span className=" text-dark extra-dark">
                  {product
                    ? productAPR
                      ? `${productAPR}%`
                      : showPercent(product.calc_adj_apy, 2)
                    : '-'}
                </span>
              </span>
              <span className="sub-text">Annualised Return (APR)</span>
              {traderRate && parseFloat(productAPR) !== traderRate && (
                <>
                  <span className="lead-text mt-1">
                    <span className="text-dark extra-dark">
                      {`${traderRate.toFixed(2)}%`}
                    </span>
                  </span>
                  <span className="sub-text">Trader Rate</span>
                </>
              )}
              {desiredRate &&
                (traderRateOverride != null ||
                  parseFloat(desiredRate) !== parseFloat(productAPR)) && (
                  <>
                    <span className="lead-text mt-1">
                      <span className="text-dark extra-dark">
                        {`${parseFloat(desiredRate).toFixed(2)}%`}
                      </span>
                    </span>
                    <span className="sub-text">Desired Fixed Rate</span>
                  </>
                )}
            </div>
            <div className="col-6">
              <span className="lead-text">
                <span className="text-dark extra-dark">
                  {product && daysLeft ? daysLeft : '-'}
                </span>
              </span>
              <span className="sub-text">Days</span>
            </div>
          </div>
          <div className="card-title text-center pt-2 mt-2 border-top">
            <span className="title form-label">
              Indicative Return on Maturity Date
            </span>
          </div>
          <div className="row">
            {currency && getCurrency(currency) === 'USD' ? (
              <>
                <div className="col-6 border-right">
                  <span className="lead-text">
                    <span className=" text-dark extra-small">
                      Reference rate
                    </span>
                  </span>
                  <span className="lead-text">
                    <span className=" text-dark extra-small">
                      {referenceRate ? referenceRate : '-'}
                    </span>
                  </span>
                </div>
                <div className="col-6">
                  <span className="lead-text">
                    <span className=" text-dark extra-small">
                      {
                        /*                        expiredAmount && referenceRate
                        ? showRoundAmount(
                            expiredAmount * referenceRate,
                            displayCurrency
                          )
                        : 0}*/
                        expiredAmount
                          ? formatIndicativeAmount(expiredAmount, currency)
                          : 0
                      }
                    </span>
                  </span>
                  <span className="lead-text">
                    <span className=" text-dark extra-small">
                      {displayCurrency ? displayCurrency.toUpperCase() : '-'}
                    </span>
                  </span>
                </div>
              </>
            ) : (
              <div className="col-12">
                <span className="lead-text">
                  <span className=" text-dark extra-small">
                    {expiredAmount
                      ? formatIndicativeAmount(expiredAmount, currency)
                      : 0}
                  </span>
                </span>
                <span className="lead-text">
                  <span className=" text-dark extra-small">
                    {currency ? getCurrency(currency) : '-'}
                  </span>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Component;
